import { render } from "./EmailTemplateEdit.vue?vue&type=template&id=18a1758a&scoped=true"
import script from "./EmailTemplateEdit.vue?vue&type=script&lang=js"
export * from "./EmailTemplateEdit.vue?vue&type=script&lang=js"

import "./EmailTemplateEdit.vue?vue&type=style&index=0&id=18a1758a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a1758a"],['__file',"src/components/mediaproperty/EmailTemplateEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18a1758a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18a1758a', __exports__)) {
    api.reload('18a1758a', __exports__)
  }
  
  module.hot.accept("./EmailTemplateEdit.vue?vue&type=template&id=18a1758a&scoped=true", () => {
    api.rerender('18a1758a', render)
  })

}


export default __exports__